import store from '@/store'

function checkPermission(el, binding) {
  const { value } = binding
  const roles = store.getters && store.getters.roles

  if (value && value instanceof Array) {
    if (value.length > 0) {
      const permissionRoles = value
      let hasPermission = false
      if (roles && roles.length > 0) {
         hasPermission = roles.some(role => {
          return permissionRoles.includes(role)
        })
      } 
    

      if (!hasPermission) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    }
  } else {
    throw new Error(`请设置操作按钮权限标签值`)
  }
}

export default {
  inserted(el, binding) {
    checkPermission(el, binding)
  },
  update(el, binding) {
    checkPermission(el, binding)
  }
} 



// WEBPACK FOOTER //
// ./src/directive/permission/permission.js